

















































import Vue from 'vue'
import { apiBlindBoxOrderPreDeliver } from '@/api'
import { navigateTo } from '@/router'
import { submit } from '@/utils'

export default Vue.extend({
  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    goods: {
      type: Object,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
  },

  computed: {
    isVisible: {
      get(): boolean {
        return this.visible
      },
      set(visible: boolean) {
        this.$emit('change', visible)
      },
    },
  },

  methods: {
    handleCancelClick() {
      this.isVisible = false
    },

    handleConfirmClick() {
      // 标销
      if (
        (this.goods.commodityType != null
          ? this.goods.commodityType
          : this.goods.commodities[0].type) === 1
      ) {
        submit(async $ => {
          $.start()
          await apiBlindBoxOrderPreDeliver({
            id: this.orderId,
          })
          this.isVisible = false
          if (this.$listeners.refresh) {
            this.$emit('refresh')
          } else {
            this.$nextTick(() => {
              navigateTo('BoxOrderList')
            })
          }
        })
      }
      // 标电
      else {
        this.isVisible = false
        if (this.$listeners.refresh) {
          this.$emit('refresh')
        }
        this.$nextTick(() => {
          navigateTo('BoxDelivery', {
            orderId: this.orderId,
          })
        })
      }
    },
  },
})
